import { getRouteApi } from "@tanstack/react-router"

const authenticatedRoute = getRouteApi("/_authenticated")

/**
 * The current user's id from the `/_authenticated` route context, which
 * guarantees it. Reads no cache and re-renders on nothing but the account.
 */
export function useCurrentUserId(): number {
	return authenticatedRoute.useRouteContext().userId
}
